import { Component, inject, OnInit } from '@angular/core';
import { SortOrder } from '@modules/common/types/sort-order';
import { ContactListStateService } from '@modules/contacts/services/contact-list-state.service';
import { ContactsService } from '@modules/contacts/services/contacts.service';
import { Contact } from '@modules/contacts/types/contact';
import { ContactsFilters } from '@modules/contacts/types/contacts-filters';
import { ContactsListState } from '@modules/contacts/types/contacts-list-state';
import { KnowledgeStitchSectionComponent } from '../stitch-section/stitch-section.component';

@Component({
  selector: 'app-knowledge-contacts-section',
  templateUrl: './contacts-section.component.html',
  styleUrls: ['../stitch-section/stitch-section.component.less'],
  standalone: false,
  providers: [
    ...ContactListStateService.providers({
      defaultSort: {
        by: 'score',
        order: SortOrder.DESC,
      },
    }),
  ],
})
export class KnowledgeContactsSectionComponent
  extends KnowledgeStitchSectionComponent<Contact, ContactsFilters>
  implements OnInit
{
  protected readonly listStateService = inject(ContactListStateService, { self: true });
  protected readonly stitchService = inject(ContactsService);

  public override ngOnInit(): void {
    this.state = new ContactsFilters({ withEmpty: true });
    super.ngOnInit();
  }

  public handleFilter(listState: ContactsListState): void {
    this.filterChange.emit();

    // Read directly, not streamed: handleFilter only runs on a user action, which is always after
    // the space settings have loaded, so the zone is already the account's (SBUX-829).
    this.filters = new ContactsFilters({ displayTimeZone: this.displayTimeZoneService.timeZone() });
    this.filters.applyListState(listState);

    this.updateFilters();
  }
}
